import React,{useState} from 'react';
import { FaMapMarkerAlt, FaBuilding, FaRupeeSign, FaInfoCircle } from 'react-icons/fa';
import '../Details/Details.css'
import { FaKey } from "react-icons/fa";
import Icard from '../Icard/Icard';
const Details = () => {
   const [isIcardOpen, setIsIcardOpen] = useState(false);
   
    const openIcard = () => {
      setIsIcardOpen(true);
    };
  
    const closeIcard = () => {
      setIsIcardOpen(false);
    };
  return (
    <div className="details-section">
     {isIcardOpen && <Icard onClose={closeIcard} />}
      <div className="detail-item">
      <div className='idd'>
        <FaMapMarkerAlt className="detail-icon" />
        </div>
        <div>
          <h4 className='d-h4'>Project Location</h4>
         
          <p className='d-p'>Sector-70, Noida, Uttar Pradesh, India</p>
        </div>
      </div>
      <div className="detail-item">
      <div className='idd'>
        <FaBuilding className="detail-icon" />
        </div>
        <div>
          <h4 className='d-h4'>Unit Variants</h4>
        
          <p className='d-p'>3 BHK + Servant Luxury Flats</p>
        </div>
      </div>
      <div className="detail-item" onClick={openIcard}>
      <div className='idd'>
        <FaRupeeSign className="detail-icon" />
        </div>
        <div>
          <h4 className='d-h4'>Starting Price</h4>
        
          <p className='d-p'>Enquire Now</p>
        </div>
      </div>
        {/*-- <div className="detail-item">
      <div className='idd'>
        <FaKey  className="detail-icon" />
        </div>
     
        <div>
        
          <h4 className='d-h4'>RERA Number</h4>
         
          <p className='d-p'>UPRERAPRJ5667</p>
        </div>
      
     
    </div>
      --*/}
    </div>
  );
};

export default Details;
